<template>
  <FileUploadField
    name="idCard"
    label="Upload photo page of id card"
    placeholder="Select or drag your file"
    iconType="NameUserCard"
    iconColor="#00D6BF"
    :errors="form.idCardErrors"
    v-model:idCard="form.idCard"
    @updateFile="updateFile"
  />
</template>

<script setup>
import { ref, watch, computed } from "vue";
import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import useFormValidation from "@/composables/validations/useFormValidation";
import { useIdentityStore } from "@/stores/forms/identityFormStore";

const { validateFileInput } = useFormValidation();
const store = useIdentityStore();
const $emit = defineEmits(["enableSubmitButton"]);
const form = ref({
  idCard: [],
  idCardErrors: null,
});

watch(form.value.idCard, () => {
  // watch for a change on the email, then update the state + validation
  const fileValidationErrors = validateFileInput("idCard", form.value.idCard);

  // @Todo: Split into it's own composable to update formstate.
  store.updateValue("idCard", form.value.idCard);
  store.updateState("idCard", fileValidationErrors);

  // Should be its own method to update the form
  form.value.passportErrors = fileValidationErrors;
});
const updateFile = (file) => {
  const fileValidationErrors = validateFileInput("idCard", file);

  form.value.idCard = file;
  store.updateValue("idCard", form.value.idCard);
  store.updateState("idCard", fileValidationErrors);
  form.value.idCardErrors = fileValidationErrors;
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.idCardErrors !== "";
  const anyFieldsEmpty = form.value.idCard.length === 0;
  return anyErrors || anyFieldsEmpty;
});

watch(
  () => formHasErrors.value,
  () => {
    $emit("enableSubmitButton", formHasErrors.value);
  },
  { deep: true }
);
</script>
<style lang="scss" scoped></style>
